






















































import Vue from "vue";
import moment from "moment";
import { logsFamilyEnumLabel, LogsFamilyEnum } from "@/model/data/enums/LogsFamilyEnum";
import { DownloadLogsProgress } from "@/model/communication/downloadLogs/DownloadLogsProgress";
import { mapGetters } from "vuex";

export default Vue.extend({
    data() {
        return { moment, LogsFamilyEnum };
    },
    props: ["downloadLogsProgress"],
    computed: {
        ...mapGetters(["userDateFormat"]),
        progress() {
            if ((this.downloadLogsProgress as DownloadLogsProgress).isDownloadCompleted) return 100;
            else {
                var trueProgress = Math.ceil(
                    ((this.downloadLogsProgress as DownloadLogsProgress).downloadedDays.length * 100) / (this.downloadLogsProgress as DownloadLogsProgress).daysToDownload.length
                );
                return trueProgress < 1 ? trueProgress : trueProgress - 1;
            }
        },
        showProgressBar() {
            if (this.downloadLogsProgress.logsFamily == LogsFamilyEnum.Machine) return false;
            if (this.downloadLogsProgress.agentVersion.startsWith("5")) return false;
            return true;
        },
    },
    methods: {
        logsFamilyEnumLabel,
    },
});
